exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".StarRating .fa-star {\n  color: gold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/scenes/MapContainer/components/PopupContainer/components/StarRating/StarRating.css
// module id = 903
// module chunks = 0